// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1BulkHoursImportSchema = z.object({
  create: z.optional(z.array(z.object({
    user_id: z.optional(z.number().int()),
    project_id: z.number().int(),
    hours: z.optional(z.number().int().min(0)),
    minutes: z.optional(z.number().int().min(0).max(59)),
    seconds: z.optional(z.number().int().min(0).max(59)),
    from: z.coerce.string().nullish(),
    to: z.coerce.string().nullish(),
    day: z.coerce.string(),
    note: z.coerce.string().nullish(),
    sequence: z.optional(z.number().int()),
    estimated_hours: z.optional(z.number().int().min(0)),
    estimated_minutes: z.optional(z.number().int().min(0).max(59)),
    billed: z.optional(z.boolean()),
    locked: z.optional(z.boolean()),
    billable: z.optional(z.boolean()),
    hour_rate: z.optional(z.number()),
    internal_hour_rate: z.optional(z.number()),
    timer_state: z.optional(z.number().int()),
    suggestion_id: z.number().int().nullish(),
    autosheet_proposal_id: z.coerce.string().nullish(),
    external_id: z.coerce.string().nullish(),
    forecast_id: z.number().int().nullish(),
    forecast_completed_at: z.coerce.string().nullish(),
    state_id: z.number().int().nullish(),
    project_join_mode: z.optional(z.enum(["add", "log_once"])),
    label_ids: z.optional(z.array(z.number().int())),
    user_ids: z.optional(z.array(z.number().int())),
    entry_ids: z.optional(z.array(z.number().int())),
    timestamps: z.optional(z.array(z.object({
      id: z.optional(z.number().int()),
      from: z.coerce.string().nullish(),
      to: z.coerce.string().nullish(),
      entry_ids: z.optional(z.array(z.number().int())),
    }))),
    external_links: z.optional(z.array(z.object({
      provider_id: z.coerce.string(),
      provider_type: z.coerce.string(),
      external_id: z.coerce.string(),
      data: z.optional(z.object({})),
      uri: z.optional(z.coerce.string()),
    }))),
  })).describe("Array of time entries to create. Each item accepts all standard event/time entry fields from PayloadSchema.")),
  update: z.optional(z.array(z.object({
    id: z.number().int().describe("Time entry ID to update"),
  })).describe("Array of time entries to update. Must include id field. All other fields from UpdatePayloadSchema are optional.")),
  delete: z.optional(z.array(z.number().int()).describe("Array of time entry IDs to delete")),
  delete_by_autosheet_proposal_id: z.coerce.string().describe("Delete every time entry linked to this AutoSheet proposal UUID in a single round-trip (autosheet revert). Honours the same permission/lock guards as `delete`; deleted IDs are returned in `deleted_ids`.").nullish(),
});
